import Vue from "vue";
import Router from "vue-router";

import Feedback from "./views/Feedback.vue";
import Error from "./views/Error.vue";

Vue.use(Router);

const router = new Router({
  //https://router.vuejs.org/guide/essentials/history-mode.html#example-server-configurations
  // nginx
  // location / {
  //   try_files $uri $uri/ /index.html;
  // }
  // nano /var/www/vhosts/system/hureacts.com/conf/nginx.conf
  mode: 'history',
  routes: [
    {
      path: "/:id",
      name: "Feedback",
      props: { default: true },
      components: { default: Feedback },
    },
   
    { path: "*", component: Error },
  ],
  scrollBehavior: (to, from) => {
    if (to.name === from.name) {
      if (to.hash) {
        return { selector: to.hash };
      }
    } else if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});


export default router;
